module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0007.jpg?v=244d9dce";